module.exports = __webpack_public_path__ + "static/media/template.5d6bc962.svg";